import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './press-releases.component.scss';
var PressReleases = /** @class */ (function (_super) {
    tslib_1.__extends(PressReleases, _super);
    function PressReleases(element) {
        return _super.call(this, element) || this;
    }
    PressReleases.prototype.init = function () { };
    PressReleases.prototype.bindEvents = function () { };
    return PressReleases;
}(Base));
export { PressReleases };



//////////////////
// WEBPACK FOOTER
// ./components/press-releases/press-releases.component.ts
// module id = 440
// module chunks = 0